/**
 * File: progressBar.js.
 *
 * Handles the page's progress bar
 */

export default {
  init() {
    this.render();
  },
  render() {
    const bar = document.querySelector('.js-moa-page-progress');
    document.addEventListener('scroll', () => {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const scrollBottom =
          (document.documentElement.scrollHeight ||
            document.body.scrollHeight) - document.documentElement.clientHeight;
      const scrollPercent = scrollTop / scrollBottom * 100;
      bar.style.setProperty('--scroll', `${ scrollPercent }%`);
    },
    { passive: true }
    );
  },
  finalize() {
  // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
